var teardownPlaceholder = () => {};

var e = teardownPlaceholder;

function start(e) {
  var r = [ e ];
  r.tag = 0;
  return r;
}

function push(e) {
  var r = [ e ];
  r.tag = 1;
  return r;
}

var identity = e => e;

function buffer(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          t(push(a));
        }
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              t(push(a));
            }
            t(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            t(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              t(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          t(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    i((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          t(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(r(e));
}

function filter(r) {
  return i => t => {
    var a = e;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function map(e) {
  return r => i => r((r => {
    if (0 === r || 0 === r.tag) {
      i(r);
    } else {
      i(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = !1;
    var s = !1;
    i((i => {
      if (s) {} else if (0 === i) {
        s = !0;
        if (!a.length) {
          t(0);
        }
      } else if (0 === i.tag) {
        f = i[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var i = e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(i);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    t(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(i = e[0]);
              i(0);
            } else if (a.length) {
              t(e);
              i(0);
            }
          }));
        }(r(i[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, i = a, t = a.length; r < t; r++) {
          i[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(r(e));
}

function onEnd(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((r => {
          if (1 === r) {
            t = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        i(r);
      }
    }));
  };
}

function onPush(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((e => {
          if (1 === e) {
            t = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        i(r);
      }
    }));
  };
}

function onStart(e) {
  return r => i => r((r => {
    if (0 === r) {
      i(0);
    } else if (0 === r.tag) {
      i(r);
      e();
    } else {
      i(r);
    }
  }));
}

function sample(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        t(r);
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return i => t => {
    var a = r;
    i((r => {
      if (0 === r) {
        t(0);
      } else if (0 === r.tag) {
        t(r);
      } else {
        t(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var i = [];
  var t = e;
  var a = !1;
  return e => {
    i.push(e);
    if (1 === i.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = i, n = i.length; r < n; r++) {
            f[r](0);
          }
          i.length = 0;
        } else if (0 === e.tag) {
          t = e[0];
        } else {
          a = !1;
          for (var s = 0, l = i, u = i.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = i.indexOf(e);
        if (f > -1) {
          (i = i.slice()).splice(f, 1);
        }
        if (!i.length) {
          t(1);
        }
      } else if (!a) {
        a = !0;
        t(0);
      }
    })));
  };
}

function skip(r) {
  return i => t => {
    var a = e;
    var f = r;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function skipUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !0;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        t(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return i => t => {
    var a = e;
    var f = !0;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          t(e);
        }
      } else {
        t(e);
      }
    }));
  };
}

function switchMap(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    i((i => {
      if (u) {} else if (0 === i) {
        u = !0;
        if (!l) {
          t(0);
        }
      } else if (0 === i.tag) {
        a = i[0];
      } else {
        if (l) {
          f(1);
          f = e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                t(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              t(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(i[0]));
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function take(r) {
  return i => t => {
    var a = e;
    var f = !1;
    var n = 0;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          t(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        t(e);
        if (!f && n >= r) {
          f = !0;
          t(0);
          a(1);
        }
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(i) {
  return t => a => {
    var f = [];
    var n = e;
    t((e => {
      if (0 === e) {
        r(f)(a);
      } else if (0 === e.tag) {
        if (i <= 0) {
          e[0](1);
          r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= i && i) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            a(1);
            t(0);
          }
        }));
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r) {
  return i => t => {
    var a = e;
    var f = !1;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        f = !0;
        t(0);
        a(1);
      } else {
        t(e);
      }
    }));
  };
}

function debounce(e) {
  return r => i => {
    var t;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (t) {
          a = !0;
        } else {
          i(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        i(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (t) {
              clearTimeout(t);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (t) {
          clearTimeout(t);
        }
        t = setTimeout((() => {
          t = void 0;
          i(r);
          if (a) {
            i(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => i => {
    var t = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        i(r);
      } else {
        t++;
        setTimeout((() => {
          if (t) {
            t--;
            i(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => i => {
    var t = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        i(0);
      } else if (0 === r.tag) {
        var f = r[0];
        i(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!t) {
        t = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          t = !1;
        }), e(r[0]));
        i(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var i = e[Symbol.asyncIterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = await i.next()).done) {
            t = !0;
            if (i.return) {
              await i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!(await i.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var i = e[Symbol.iterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = i.next()).done) {
            t = !0;
            if (i.return) {
              i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!i.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var r = fromIterable;

function fromValue(e) {
  return r => {
    var i = !1;
    r(start((t => {
      if (1 === t) {
        i = !0;
      } else if (!i) {
        i = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var i = !1;
    var t = e({
      next(e) {
        if (!i) {
          r(push(e));
        }
      },
      complete() {
        if (!i) {
          i = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !i) {
        i = !0;
        t();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((i => {
      e = i.next;
      r = i.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((i => {
    if (1 === i) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(e));
};

function interval(e) {
  return make((r => {
    var i = 0;
    var t = setInterval((() => r.next(i++)), e);
    return () => clearInterval(t);
  }));
}

function fromDomEvent(e, r) {
  return make((i => {
    e.addEventListener(r, i.next);
    return () => e.removeEventListener(r, i.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return i => {
    var t = e;
    var a = !1;
    i((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else if (!a) {
        r(e[0]);
        t(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          t(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

function toArray(r) {
  var i = [];
  var t = e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (t = e[0])(0);
    } else {
      i.push(e[0]);
      t(0);
    }
  }));
  if (!a) {
    t(1);
  }
  return i;
}

function toPromise(r) {
  return new Promise((i => {
    var t = e;
    var a;
    r((e => {
      if (0 === e) {
        i(a);
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else {
        a = e[0];
        t(0);
      }
    }));
  }));
}

function zip(r) {
  var i = Object.keys(r).length;
  return t => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(i).fill(e) : {};
    var n = Array.isArray(r) ? new Array(i) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= i - 1) {
            u = !0;
            t(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < i) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            t(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    t(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var i in f) {
          f[i](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

var observableSymbol = () => Symbol.observable || "@@observable";

function fromObservable(e) {
  e = e[observableSymbol()] ? e[observableSymbol()]() : e;
  return r => {
    var i = e.subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error() {}
    });
    r(start((e => {
      if (1 === e) {
        i.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(i) {
      var t = e;
      var a = !1;
      r((e => {
        if (a) {} else if (0 === e) {
          a = !0;
          i.complete();
        } else if (0 === e.tag) {
          (t = e[0])(0);
        } else {
          i.next(e[0]);
          t(0);
        }
      }));
      var f = {
        closed: !1,
        unsubscribe() {
          f.closed = !0;
          a = !0;
          t(1);
        }
      };
      return f;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, i) => {
      if (0 === e) {
        r(start((e => {
          i(e + 1);
        })));
      } else if (1 === e) {
        r(push(i));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, i) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          i(2);
        } else if (0 === e.tag) {
          i(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          i(1, e[0]);
        }
      }));
    }
  };
}

function pipe(...e) {
  var r = e[0];
  for (var i = 1, t = e.length; i < t; i++) {
    r = e[i](r);
  }
  return r;
}

export { buffer, combine, concat, concatAll, concatMap, debounce, delay, empty, filter, mergeAll as flatten, forEach, r as fromArray, fromAsyncIterable, fromCallbag, fromDomEvent, fromIterable, fromObservable, fromPromise, fromValue, interval, lazy, make, makeSubject, map, merge, mergeAll, mergeMap, never, onEnd, onPush, onStart, pipe, publish, sample, scan, share, skip, skipUntil, skipWhile, subscribe, switchAll, switchMap, take, takeLast, takeUntil, takeWhile, onPush as tap, throttle, toArray, toCallbag, toObservable, toPromise, zip };
//# sourceMappingURL=wonka.mjs.map
